import { Button } from 'bz-core-controls';
import Modal from 'bz-core-controls/modal';
import InvoiceType from 'bz-pronto-core/enum/invoice-type';
import ProntoInvoiceStatus from 'bz-pronto-core/enum/pronto-invoice-status';
import GUID from 'bz-utilities/modules/variables/guid';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import Api from 'tm3-core/api';
import Dialog from 'tm3-core/controls/modal/core-dialog';

@observer
class AcknowledgeDialog extends React.Component {
  @observable acknowledged = false;

  render() {
    if (!this.show) return null;

    let actions = [<Button onClick={this.onClick}>Acknowledge</Button>];

    return (
      <Dialog open={true} title="Invoice Rejected" actions={actions}>
        <div>The referrer rejected this invoice with the following message</div>
        <div>{this.metadata.message}</div>
      </Dialog>
    );
  }

  @computed
  get metadata() {
    let { invoice = {} } = this.props;
    return invoice.metadata || {};
  }

  @computed
  get show() {
    let { invoice = {} } = this.props;
    let { globalId, globalType } = invoice;

    if (globalType !== InvoiceType.Pronto || !GUID.hasValue(globalId)) return false;

    return this.metadata.status === ProntoInvoiceStatus.Rejected && !this.acknowledged;
  }

  @action.bound
  onClick() {
    const { invoice = {} } = this.props;
    const { id } = invoice;

    Api.post(`/api/invoice/${id}/acknowledge`, {})
      .then((res) => {
        const { result } = res.body;
        if (!result) throw 'Unable To Update Status';

        this.metadata.status = ProntoInvoiceStatus.acknowledged;
        this.acknowledged = true;
      })
      .catch(() => {
        const modal = {
          alert: true,
          title: 'Invoice Status',
          description: 'We were unable to update the status of this invoice'
        };
        Modal.confirmation(modal).then(() => {
          this.acknowledged = true;
        });
      });
  }
}

export default AcknowledgeDialog;
